<template>
  <display-section gap="l">
    <render />
  </display-section>
</template>
<script setup>
const {
  libraryViewRouter: { view },
} = inject(INJECT_LIBRARY_PAGE_OR_FORM);

const render = () => {
  return h(view.value);
};
</script>
